<!-- @Description 运营决策智能体 -->
<template>
  <div class="product-operation-decision">
    <div class="info">
      <div class="title">运营决策智能体</div>
      <div class="content">
        基于我们的认知智能算法平台，嵌入整个企业营运中，以支持业务流程及通用任务执行。透过整合企业数据、业务规则、领域知识及营运工作流程，该等智能体协助企业进行知识管理、数据分析、任务执行及营运决策。
      </div>
    </div>
    <div class="feature">
      <div class="title">特色优势</div>
      <div class="content">
        基于本体知识场，我们打造白盒可解释、安全可审计的可信智能，让企业“敢用”；凭借快速知识理解与融合推理能力，我们以大小模型互补及多智能体协同为引擎，不仅提供标准化工具，更深度适配客户业务，以可量化决策价值说话。
      </div>
      <img
        :src="featureImg"
        alt="运营决策智能体特色优势"
        class="feature-img"
      />
    </div>
    <div class="product">
      <div class="title">产品矩阵</div>
      <div
        class="product-catgory"
        v-for="cat in categories"
        :key="cat.key"
      >
        <div
          class="product-catgory-item"
          @click="goCategory(cat.key)"
        >
          <div
            class="product-catgory-item-title"
            :class="
              cat.bgType === 1
                ? 'product-catgory-item-title1'
                : 'product-catgory-item-title2'
            "
          >
            <div class="title-row">
              <span class="title-text">{{ cat.title }}</span>
              <img
                :src="arrowIcon"
                class="title-arrow"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cases">
      <div class="title">客户案例</div>
      <Case
        :data.sync="case_list"
        :is-categorized="true"
        class="case-list"
      />
    </div>
    <div class="more">
      更多案例请联系我们
    </div>
    <div class="visitingCard">
      <VisitingCard :data="visitlist" />
    </div>
  </div>
</template>
<script>
import Case from "@/components/customerCase.vue";
import VisitingCard from "@/components/visitingCard.vue";
import featureImg from "@/../static/img/operationDecision/综合运营特色优势_dark.png";
import arrowIcon from "@/../static/img/other/arrow.svg";
import { OPERATION_DECISION_CATEGORIES } from "./categoryData";
export default {
  name: "product-operation-decision",
  components: {
    Case,
    VisitingCard
  },
  data() {
    return {
      featureImg,
      arrowIcon,
      categories: OPERATION_DECISION_CATEGORIES,
      case_list: [
        {
          category: "互动展示",
          cases: [
            {
              title: '新一代智能化展厅案例',
              img: "../../../static/img/operationDecision/case_博物馆.jpg",
              video: "",
              content:
                "构建面向信息展示场景的智能体，实现线下展示空间数据实时更新与内容智能调度，支持智能讲解问答与多展示模式一键切换，推动展厅持续自优化运营，全面提升展示与传播效率。",
              isplay: false
            },
            {
              title: "可持续生长的博物馆物件剧场数字展厅案例",
              img: "../../../static/img/operationDecision/case_展厅.jpg",
              video: "",
              content:
                "构建“库—展—演”三层动态内容体系，实现展陈内容的分层组织、动态更新与持续演化，推动展厅从静态展示向可生长、可扩展的智能展陈体系升级，并提升运营决策能力。",
              isplay: false
            }
          ]
        },
        {
          category: "研发生产",
          cases: [
            {
              title: "某钢产线质量问数",
              img: "../../../static/img/operationDecision/case_某钢产线质量问数.png",
              video: "",
              content:
                "通过部署数据分析智能体，实现生产管理人员直接通过自然语言问答，自动生成统计图表。实施过程中融合业务指标和业务逻辑，使得AI智能体不仅会统计也懂业务。项目私有化部署，数据对接更安全。",
              isplay: false
            }
          ]
        },
        {
          category: "财务",
          cases: [
            {
              title: "固定资产稽核智能体",
              img: "../../../static/img/operationDecision/case_固定资产稽核.png",
              video: "",
              content:
                "基于财务资产管理本体，构建涵盖资产分类、折旧规则生命周期状态等核心概念的知识框架，实现从数据层到语义层的统一建模。智能体以线下同源维护系统、ERP资产模块等多源数据为输入，通过本体驱动的推理引擎，自动完成资产卡片的语义校验、异常识别与逻辑关联分析；同时依托记忆机制持续沉淀稽核经验，实现问题预警、根因诊断及纠错执行的闭环自治，推动固定资产管理从规则驱动向认知驱动、从粗放式向精细化跃迁。",
              isplay: false
            },
            {
              title: "违法分包智能审计",
              img: "../../../static/img/operationDecision/case_违法分包审计.png",
              video: "",
              content:
                '基于违法分包审计本体，将法规规则、合同关系、资质约束等合规知识形式化建模。智能体通过本体驱动的语义提取与逻辑推理，自动识别违法转包、违规分包、资质挂靠等风险模式的深层关联，贯通"合同获取—深度解析—合规审查—结果追溯"的全流程认知审计闭环，为审计人员提供即时、权威、可解释的合规风险诊断。该场景已入选总部全网推广的人工智能标杆场景应用。',
              isplay: false
            }
          ]
        },
        {
          category: "运营决策",
          cases: [
            {
              title: "AI 日报分析驾驶舱",
              img: "../../../static/img/operationDecision/case_AI日报分析驾驶舱.png",
              video: "",
              content:
                '融合行业知识、数据挖掘与大模型技术，围绕煤炭企业产量、销量、库存、质量、价格及安全生产等核心数据，构建覆盖研发生产、智能问数、智能报告和辅助决策的 AI 智能体体系，让数据从"看得见"走向"看得懂、用得上、能决策"。',
              isplay: false
            }
          ]
        }
      ],
      visitlist: []
    };
  },
  methods: {
    goCategory(key) {
      this.$router.push({
        name: "product_operationDecision_category",
        params: { key }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.product-operation-decision {
  width: 100%;
  padding: 96px 0px 0px;
  .info {
    width: 100%;
    height: 432px;
    background: url("../../../../static/img/product/page_header_bg.png")
      no-repeat center / cover;
    overflow: hidden;
    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }
    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
      text-align: justify;
    }
  }
  .feature {
    padding: 44px 64px;
    background: url("../../../../static/img/product/product_matrix_bg.png")
      no-repeat center / cover;
    .title {
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }
    .content {
      margin-top: 16px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      text-align: justify;
    }
    .feature-img {
      width: 100%;
      margin-top: 44px;
      display: block;
    }
  }
  .product {
    .title {
      font-size: 40px;
      color: #08204d;
      line-height: 56px;
      text-align: center;
      margin-top: 44px;
    }
    .product-catgory {
      .product-catgory-item {
        cursor: pointer;
        .product-catgory-item-title {
          position: relative;
          width: 100%;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 64px;
          box-sizing: border-box;
          .title-row {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .title-text {
            font-size: 32px;
            color: #08204d;
            line-height: 44px;
          }
          .title-arrow {
            flex-shrink: 0;
            height: 16px;
            width: auto;
            opacity: 0.72;
            transition: opacity 0.25s ease;
            animation: arrowNudgeRight 2.2s ease-in-out infinite;
          }
        }
        &:active .title-arrow {
          animation: none;
          opacity: 1;
          transform: translateX(4px);
        }
        .product-catgory-item-title1 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg1.png")
            no-repeat left center / 100%;
        }
        .product-catgory-item-title2 {
          background: url("../../../../static/img/product/product_society_arithmetic_bg2.png")
            no-repeat left center / 100%;
        }
      }
    }
  }
  @keyframes arrowNudgeRight {
    0%,
    100% {
      transform: translateX(-4px);
      opacity: 0.45;
    }
    50% {
      transform: translateX(6px);
      opacity: 0.85;
    }
  }
  .cases {
    .title {
      margin-top: 44px;
      font-size: 40px;
      font-weight: 500;
      color: #08204d;
      line-height: 56px;
      text-align: center;
    }
    .case-list {
      width: calc(100% - 110px);
      margin: 24px 55px 0;
    }
  }
  .more {
    height: 52px;
    font-weight: 400;
    font-size: 22px;
    color: #97a2b5;
    line-height: 52px;
    text-align: center;
    font-style: normal;
    margin: 16px 0;
  }
  .visitingCard {
    width: calc(100% - 128px);
    padding: 40px 64px;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/operationDecision/index.vue